<template>
  <div id="wrapper" class="">
    <!-- This page only redirects into the survey; show a loader instead of the
         stages grid so it doesn't flash while the airport fetch resolves. -->
    <div v-if="redirecting" class="container" style="height: 100vh;">
      <div class="success-right-section" style="display:flex; flex-direction:column; align-items:center; justify-content:center; width:100%; height:100%;">
        <img alt="Loading" :src="require('@/assets/img/asideImage/loader.gif')" style="height: 280px;" />
        <p class="text-center mt-3">Loading your survey...</p>
      </div>
    </div>

    <div v-else class="container">
      <div class="left-section">
        <div class="asideHead">
          <img :src="require('@/assets/img/logo.png')" alt="Logo" style="height: 60px;">
        </div>
        <div class="asideBody">
          <!-- Render image based on page number -->
          <img :src="require('@/assets/img/asideImage/gallery.gif')" style="height: 320px;">
          <h2>Airport Adventures Await – Spill the Beans on Your Journey!</h2>
        </div>
        <div class="asideFoot">
          <small class="text-gray powered">Powered by</small> <img :src="require('@/assets/img/CIC.png')" style="height: 30px;">
        </div>
      </div>
      <div class="right-section" style="height: 100vh;padding: 30px;overflow-y: auto;">
        <div class="text-center hideElement">
          <img :src="require('@/assets/img/logo.png')" alt="Logo" style="height: 60px;margin-bottom: 20px;"><br>
        </div>
        <div class="text-center heroBanner">
          <img :src="require('@/assets/img/banner.png')" alt="" />
          <h4 class="centered">Your Journey Matters<br>Share Your Travel Experience!</h4>
        </div><br>
        <div class="stages-container row justify-content-center">
          <div v-for="stage in stages" :key="stage.id" class="col-lg-4 col-md-4 col-sm-4 col-xs-6 text-center mb-3">
            <a class="g-thumbnail" :class="{ '': !canAccessStage(stage.id) }" @click="navigateToStage(stage.id)">
              <img :src="getStageImage(stage.id)" class="img-fluid" alt="Stage Image" />
              <span>{{ stage.name }}</span>
              <div class="play-button" v-if="!canAccessStage(stage.id)">&#x1f512;</div>
              <div class="play-button" v-else-if="stage.completed">&#9658;</div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axiosInstance from '@/axiosInstance';
import surveyService from '@/services/surveyService';
import { computed, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';

export default {
  setup() {
    const router = useRouter();
    const stages = computed(() => surveyService.getStages());
    // This page only ever redirects into the survey; keep the stages grid hidden
    // while we resolve the airport fetch + navigation so it doesn't flash on load.
    const redirecting = ref(true);

    const fetchAirportInfo = async (qrId) => { 
      try {
        const response = await axiosInstance.get(`/public/get-details/qr-code/${qrId}`); // Use qrId correctly
        const airportName = response?.data?.airport?.name;
        console.log('Air', airportName);
        // Only autofill Q2a when we actually got a name (avoid storing undefined)
        if (airportName) {
          surveyService.setAnswer('2a', airportName);
        }
      } catch (error) {
        console.error('Error fetching airport info:', error);
      }
    };

    onMounted(async () => {
      if (surveyService.isSurveySubmitted().restrictSubmission) {
        router.push({ name: 'SurveyEnd' });
        return;
      }

      const qrcode = localStorage.getItem("qrcode");
      if (qrcode) {
        // Await so Q2a is autofilled BEFORE we navigate into the survey stage
        await fetchAirportInfo(qrcode);
      } else {
        console.error("QR code not found in localStorage");
      }

      // 👉 Navigate to the first accessible stage
      const availableStage = surveyService.getStages().find(stage => canAccessStage(stage.id));
      if (availableStage) {
        router.push({ name: 'SurveyStage', params: { stageNumber: availableStage.id } });
      } else {
        // No stage to enter — reveal the stages grid as a fallback
        redirecting.value = false;
      }
    });



    const canAccessStage = (stageId) => {
      return surveyService.canAccessStage(stageId);
    };

    const allStagesCompleted = computed(() => {
      return stages.value.every((stage) => stage.completed);
    });

    const navigateToStage = (stageId) => {
      if (canAccessStage(stageId)) {
        router.push({ name: 'SurveyStage', params: { stageNumber: stageId } });
      }
    };

    const submitSurvey = async () => {
      console.log('Survey Answers:', surveyService.getAnswers());
      const qrcode = localStorage.getItem('qrcode');
      console.log('QR Code:', qrcode);

      try {
        const response = await axiosInstance.post('public/answers', {
          qr_id: qrcode,
          question_id: 1,
          answer: surveyService.getAnswers(),
          unique_id: surveyService.getUniqueId(), // ✅ Added unique_id
        });

        console.log('Response from API:', response.data);
        alert('Survey submitted successfully!');
      } catch (error) {
        console.error('Error submitting survey:', error);
        alert('Failed to submit survey. Please try again.');
      }
    };

    const getStageImage = (stageId) => {
      return require(`@/assets/img/stage${stageId}.svg`);
    };

    return {
      stages,
      redirecting,
      canAccessStage,
      allStagesCompleted,
      navigateToStage,
      submitSurvey,
      getStageImage,
      fetchAirportInfo,
    };
  },
};
</script>

